import { useSettings } from '../providers/SettingsProviders'

export function useCheckoutEnabled() {
  const { settings } = useSettings()

  return settings?.uiSettings.showCheckout
}
